import { Skeleton } from "@mui/material"

export const ListLoader = () => {
    return (
        ['','','','',''].map((v,k) => (
            <Skeleton key={k} variant="rectangular" sx={{height:'65px', borderRadius:'10px', bgcolor:'#F0F6F3'}} />
        ))
    )
}